import { useEffect, useState } from 'react'

export const useActionWhenVisible = ({ action, isActionDisabled, inView }) => {
  const [actionExecuted, setActionExecuted] = useState(false)
  useEffect(() => {
    if (inView && !isActionDisabled && !actionExecuted) {
      setActionExecuted(true)
      action()
    }
  }, [action, actionExecuted, inView, isActionDisabled])
}
